module.exports = __webpack_public_path__ + "static/media/pumpkin.00319e3c.png";